import { render, staticRenderFns } from "./reviewTraining.vue?vue&type=template&id=88e628dc&scoped=true"
import script from "./reviewTraining.vue?vue&type=script&lang=js"
export * from "./reviewTraining.vue?vue&type=script&lang=js"
import style0 from "./reviewTraining.vue?vue&type=style&index=0&id=88e628dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88e628dc",
  null
  
)

export default component.exports